import React from 'react';
import _ from 'lodash';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { rhythm } from '../utils/typography';
import { BadgeList } from '../components/badge';

const Title = styled.h1`
  margin-top: ${rhythm(1)};
  margin-bottom: ${rhythm(1)};
`;

type Props = {
  data: {
    allMarkdownRemark: {
      group: {
        fieldValue: string;
        totalCount: number;
      }[];
    };
    site: {
      siteMetadata: {
        title: string;
      };
    };
  };
};

const TagsPage: React.FC<Props> = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout>
    <SEO title={title} />
    <Title>Tags</Title>
    <BadgeList
      data={group.map(tag => {
        return {
          to: `/tags/${_.kebabCase(tag.fieldValue)}/`,
          text: `${tag.fieldValue} (${tag.totalCount})`,
        };
      })}
    />
  </Layout>
);

export default TagsPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
